/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".customer-wrapper-footer[_ngcontent-%COMP%]   .mat-toolbar-multiple-rows[_ngcontent-%COMP%]{min-height:36px!important}.customer-wrapper-footer[_ngcontent-%COMP%]   .mat-toolbar-row[_ngcontent-%COMP%]{color:#fff}.customer-wrapper-footer[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]{position:fixed;bottom:0;width:100%;height:36px;z-index:11;padding:0 10%}"];
export { styles as styles };
